import tw, { styled, css } from 'twin.macro';
import { Gilroy } from 'gilroy-global';
import DargIcon from 'assets/svgs/move.svg';
import { getCSRFToken } from 'utils';
import { useCookies } from 'react-cookie';
import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const WbGilroy = () => {
  const { pathname } = useLocation();
  const csrfToken = getCSRFToken();
  const [gilroyFlag, setExtra] = useState(false);
  const [cookies] = useCookies();
  const isLogout = cookies?.isLogout;

  const initialPosition = {
    x: window.innerWidth - 150,
    y: window.innerHeight - 130,
  };
  const [position, setPosition] = useState(initialPosition);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    if (isLogout && isLogout !== '1' && csrfToken) {
      setExtra(true);
    } else {
      setExtra(false);
    }
  }, [isLogout, csrfToken]);

  const handleMouseDown = (e: any) => {
    setIsDragging(true);
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };

  const handleMouseMove = useCallback(
    (e) => {
      if (!isDragging) return;

      const newX = e.clientX - offset.x;
      const newY = e.clientY - offset.y;

      // Screen boundaries check
      const clampedX = Math.max(0, Math.min(newX, window.innerWidth - 125));
      const clampedY = Math.max(0, Math.min(newY, window.innerHeight - 110));

      setPosition({
        x: clampedX,
        y: clampedY,
      });
    },
    [isDragging, offset],
  );

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    } else {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    }
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, handleMouseMove]);

  const isOnBoardingPage = pathname.includes('/welcome');
  return (
    <>
      {!isOnBoardingPage && gilroyFlag && (
        <div style={{ position: 'relative' }}>
          {isDragging && <DragContainer />}
          <Dragable
            style={{
              left: `${position.x}px`,
              top: `${position.y}px`,
            }}
          >
            <MoveIcon className="moved-icon" onMouseDown={handleMouseDown} src={DargIcon} />
            <WbGilroyStyle isVisible={gilroyFlag} isDragging={isDragging}>
              <Gilroy gilroyStates={{}} gilroyActions={{}} />
            </WbGilroyStyle>
          </Dragable>
        </div>
      )}
    </>
  );
};

export default WbGilroy;

const DragContainer = styled.div(() => [tw`w-screen h-screen absolute z-50`]);

const Dragable = styled.div(() => [
  tw`z-[99] fixed`,
  css`
    &:hover:has(.content-popover-c) .moved-icon {
      display: inline;
      transition: opacity 0.3s ease;
    }
  `,
]);

const MoveIcon = styled.img(() => [tw`w-[25px] h-[25px] absolute z-10 cursor-move hidden`]);

const WbGilroyStyle = styled.div(() => [
  tw`relative`,
  css`
    .content-popover-c {
      z-index: 10 !important;
      position: unset !important;
    }
  `,
]);
